<ng-container *ngIf="!!get">
    <tt-toast *ngIf="!!get.message" [ttTitle]="get.message" ttTranslateTitle="false" ttType="warning"></tt-toast>
    <tt-grid *ngIf="!!grid && +get.grid_datatask > 0" [(ttOptions)]="grid"></tt-grid>
</ng-container>
